import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-725a0e08"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-image", $options.finalClasses]),
    style: _normalizeStyle($options.finalStyles)
  }, [_createElementVNode("img", {
    class: "c-image-img",
    src: $props.src,
    style: _normalizeStyle($options.finalImgStyles),
    onLoad: _cache[0] || (_cache[0] = (...args) => $options.handleLoad && $options.handleLoad(...args))
  }, null, 44, _hoisted_1)], 6);
}